(function () {

    'use strict';

    angular.module('iplusjs.validator.isGreaterThan', [
        'iplusjs.utils.misc'
    ])
    .directive('iplusjsIsGreaterThan', isGreaterThan);

    isGreaterThan.$inject = [
        'MiscUtilsService'
    ];
    function isGreaterThan(MiscUtilsService) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function ($scope, $element, $attrs, $ngModel) {
                var compareVal,
                    equalAllowed = $scope.$eval($attrs.iigtEqualAllowed) || false,
                    byYear = $scope.$eval($attrs.iigtByYear) || false;

                $scope.$watch($attrs.iplusjsIsGreaterThan, function (value) {
                    compareVal = MiscUtilsService.getValueCustomObject(value);

                    if (MiscUtilsService.isNotEmpty(compareVal)) {
                        $ngModel.$validate();
                    }
                });

                function isGreaterThanValidator(value) {
                    var val = MiscUtilsService.getValueCustomObject(value);

                    return MiscUtilsService.isGreaterThan(val, compareVal, {
                        equalAllowed: equalAllowed, // Sind gleiche Werte erlaubt oder muss der Wert größer sein,
                        byYear: byYear // Bei einem Datum nur auf das Jahr schauen
                    });
                }

                $ngModel.$validators.isGreaterThan = isGreaterThanValidator;
            }
        };
    }
})();
